import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, track } from "@/lib/analytics";

export default function AnalyticsTracker() {
  const loc = useLocation();
  useEffect(() => { trackPageview(loc.pathname); }, [loc.pathname]);
  useEffect(() => {
    const onHide = () => { if (document.visibilityState === "hidden") track("end"); };
    const onPageHide = () => track("end");
    document.addEventListener("visibilitychange", onHide);
    window.addEventListener("pagehide", onPageHide);
    return () => {
      document.removeEventListener("visibilitychange", onHide);
      window.removeEventListener("pagehide", onPageHide);
    };
  }, []);
  return null;
}
